<div class="loading" *ngIf="isLoading; else content">
  <mat-spinner [diameter]="32"></mat-spinner>
  <p>{{ 'dashboard.loading' | translate }}</p>
</div>
<ng-template #content>
  <mat-checkbox
    [checked]="selectedInstances.length > 0 && selectedInstances.length === this.nbInstances"
    [indeterminate]="selectedInstances.length > 0 && selectedInstances.length !== this.nbInstances"
    (change)="toggleSelectAll()">
    <ng-container *ngIf="selectedInstances.length > 0 && selectedInstances.length === this.nbInstances; else selectAll">
      {{ 'scc-popup.deselect-all' | translate }}
    </ng-container>
    <ng-template #selectAll>
      {{ 'scc-popup.select-all' | translate }}
    </ng-template>
  </mat-checkbox>

  <ng-container *ngFor="let serie of study?.series">
    <div class="serie" *ngIf="serie.modalityType?.isRadio">
      <p>{{ serie.date | dateLocale:'medium' }} {{ serie.name }}</p>
      <div class="grid">
        <div class="instance" *ngFor="let instance of serie.instances">
          <app-preview-card
            [hash]="serie.previewHash"
            [status]="study?.studyStatus"
            [previewPublicId]="instance.publicid"
            [modalityTypeName]="serie.modalityType?.value"
            [bigPreview]="true"></app-preview-card>
          <div class="check">
            <mat-checkbox [checked]="isSelected(instance)" (change)="toggleSelectInstance(instance)">
              <ng-container *ngIf="isSelected(instance); else select">{{ 'scc-popup.deselect' | translate }}</ng-container>
              <ng-template #select>{{ 'scc-popup.select' | translate }}</ng-template>
            </mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngFor="let studyPatient of study?.patient?.studies">
    <ng-container *ngFor="let serie of studyPatient?.series">
      <div class="serie" *ngIf="serie.modalityType?.isRadio && study?.id !== studyPatient.id">
        <p>{{ 'scc-popup.studies-others' | translate }} {{ serie.date | dateLocale:'medium' }} {{ serie.name }}</p>
        <div class="grid">
          <div class="instance" *ngFor="let instance of serie.instances">
            <app-preview-card
              [hash]="serie.previewHash"
              [status]="studyPatient?.studyStatus"
              [previewPublicId]="instance.publicid"
              [modalityTypeName]="serie.modalityType?.value"
              [bigPreview]="true"></app-preview-card>
            <div class="check">
              <mat-checkbox [checked]="isSelected(instance)" (change)="toggleSelectInstance(instance)">
                <ng-container *ngIf="isSelected(instance); else select">{{ 'scc-popup.deselect' | translate }}</ng-container>
                <ng-template #select>{{ 'scc-popup.select' | translate }}</ng-template>
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <div class="selected" *ngIf="this.selectedInstances.length > 0">
    <p>{{ 'scc-popup.selected' | translate: { count: selectedInstances.length } }}</p>
  </div>
</ng-template>
